document.addEventListener("DOMContentLoaded", function () {
  console.log("Script loaded successfully!"); // Confirm script is running

  // Variables
  const questions = document.querySelectorAll(".question"); // All quiz questions
  const progressBar = document.getElementById("progress-bar"); // Progress bar element
  let currentStep = 0; // Tracks the current question
  const userSelections = {}; // Stores answers for each question

  // Function: Show the next question or redirect
  function handleNextStep() {
    if (currentStep < questions.length - 1) {
      questions[currentStep].classList.remove("active");
      currentStep++;
      if (questions[currentStep]) {
        questions[currentStep].classList.add("active");
      }
      updateProgressBar();
      updateBackButton();
      console.log(`Moving to question ${currentStep}`);
    } else {
      console.log("All questions completed. Redirecting to results.");
      redirectToResults();
    }
  }

  // Function: Show the previous question
  function handlePreviousStep() {
    if (currentStep > 0) {
      questions[currentStep].classList.remove("active");
      currentStep--;
      if (questions[currentStep]) {
        questions[currentStep].classList.add("active");
      }
      updateProgressBar();
      updateBackButton();
      console.log(`Returning to question ${currentStep}`);
    }
  }

  // Function: Update the Back button visibility
  function updateBackButton() {
    document.querySelectorAll(".back-button").forEach((button, index) => {
      button.style.display = index === currentStep && currentStep > 0 ? "inline-block" : "none";
    });
  }

  // Function: Redirect to the correct Smart Collection
  function redirectToResults() {
    console.log("Redirecting to results...");

    if (!userSelections["0"] || !userSelections["1"] || !userSelections["2"]) {
      alert("Please answer all questions to find the perfect gift!");
      return;
    }

    // ✅ FIX: Use **only** the exact single-age handle, no expansion
    const ageMap = {
      "0+": "0plus",
      "1+": "1plus",
      "2+": "2plus",
      "3+": "3plus",
      "4+": "4plus",
      "5+": "5plus",
      "6+": "6plus",
      "7+": "7plus",
      "8+": "8plus"
    };

    // ✅ FIX: Ensure **only** the selected age tag is used
    const ageTag = ageMap[userSelections["0"]];

    // Convert budget and category to Shopify-compatible format
    const budgetTag = userSelections["1"].replace("£", "").toLowerCase();
    const categoryTag = userSelections["2"].replace(/ /g, "-").toLowerCase();

    // ✅ FIX: Ensure only **one** age tag is included
    if (!ageTag) {
      console.error("Invalid age selection. Redirection stopped.");
      return;
    }

    // Construct the final Smart Collection handle
    const collectionHandle = `${ageTag}-${budgetTag}-${categoryTag}`;
    const resultsURL = `/collections/${collectionHandle}`;

    console.log("Constructed Handle:", collectionHandle);
    console.log("Constructed URL:", resultsURL);

    // Redirect the user
    try {
      window.location.assign(resultsURL);
    } catch (error) {
      console.error("Redirection failed:", error);
      alert("There was an error redirecting. Please try again.");
    }
  }

  // Function: Update the progress bar
  function updateProgressBar() {
    const progress = ((currentStep / (questions.length - 1)) * 100).toFixed(0);
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
      console.log(`Progress bar updated: ${progress}%`);
    }
  }

  // ✅ FIX: Check that questions exist before setting classList
  if (questions.length > 0) {
    questions[0].classList.add("active");
  }

  // Event listener for answer buttons
  document.querySelectorAll(".answer").forEach((button) => {
    button.addEventListener("click", function () {
      const parentId = this.closest(".question")?.id;
      if (!parentId) return;

      const questionIndex = parentId.replace("question-", "");
      const selectedTag = this.getAttribute("data-tag");

      userSelections[questionIndex] = selectedTag;

      console.log(`Question ${questionIndex} answered with: ${selectedTag}`);
      console.log("Current user selections:", userSelections);

      handleNextStep();
    });
  });

  // Event listener for Back buttons
  document.querySelectorAll(".back-button").forEach((button) => {
    button.addEventListener("click", handlePreviousStep);
  });

  updateBackButton();
  console.log("Quiz initialized. Ready to start!");
});
 